/**
 * Configurações do chat (regra 3 das diretrizes: config com tela).
 *
 * - "Para mim": os avisos deste aparelho (ligar/desligar — saiu do topo da
 *   lista em 2026-10-28: uma vez ligado, só se mexe aqui), o texto na
 *   notificação (ligado por padrão, como no WhatsApp) e o som de mensagem
 *   nova (um de três, o mesmo no Cut);
 * - "Unidade": só para quem tem `chat_grupos:gerenciar` (o servidor diz em
 *   `pode_configurar`) — janela de edição, limites de arquivo, arquivamento
 *   do lote e perguntas ao assistente por dia (0 desliga).
 */
import { useEffect, useState } from "react";

import { ControleDeNotificacoes } from "../../components/NotificacoesDoChat";
import { preferenciasDoChat, salvarConfiguracaoDoChat, salvarPreferenciasDoChat } from "../../services/chat";
import { Modal } from "./Dialogos";
import { ICONE, Ic } from "./Icones";
import { SOM_PADRAO, SONS, escolherSom, tocarAviso } from "./som";

const CAMPOS_DA_UNIDADE = [
  { campo: "janela_edicao_min", rotulo: "Editar ou apagar vale por (minutos)" },
  { campo: "limite_arquivo_mb", rotulo: "Tamanho máximo do arquivo (MB)" },
  { campo: "limite_video_mb", rotulo: "Tamanho máximo do vídeo (MB)" },
  { campo: "dias_arquivar_lote", rotulo: "Arquivar a conversa do lote depois do corte (dias)" },
  { campo: "limite_assistente_dia", rotulo: "Perguntas ao assistente por dia na unidade (0 desliga)" },
];

export function ConfiguracoesDoChat({ request, config, aoSalvar, aoFechar, toast }) {
  const [comTexto, setComTexto] = useState(null);
  const [som, setSom] = useState(null);
  const [valores, setValores] = useState(() => Object.fromEntries(CAMPOS_DA_UNIDADE.map(({ campo }) => [campo, config?.[campo] ?? ""])));
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    preferenciasDoChat(request)
      .then((p) => {
        setComTexto(p?.notificacao_com_texto !== false);
        setSom(p?.som_do_aviso || SOM_PADRAO);
      })
      .catch(() => {
        setComTexto(true);
        setSom(SOM_PADRAO);
      });
  }, [request]);

  const mudarSom = async (novo) => {
    const anterior = som;
    setSom(novo);
    escolherSom(novo);
    tocarAviso(novo);
    try {
      await salvarPreferenciasDoChat(request, { som_do_aviso: novo });
    } catch {
      setSom(anterior);
      escolherSom(anterior);
      toast.error("Não deu para salvar o som.");
    }
  };

  const mudarTexto = async (valor) => {
    setComTexto(valor);
    try {
      await salvarPreferenciasDoChat(request, { notificacao_com_texto: valor });
    } catch {
      setComTexto(!valor);
      toast.error("Não deu para salvar a preferência.");
    }
  };

  const salvarUnidade = async () => {
    setSalvando(true);
    try {
      const corpo = Object.fromEntries(Object.entries(valores).map(([k, v]) => [k, Number(v)]));
      aoSalvar(await salvarConfiguracaoDoChat(request, corpo));
      toast.success("Configurações do chat salvas.");
    } catch {
      /* o request já avisou */
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal open titulo="Configurações do chat" aoFechar={aoFechar}>
      <section className="pchat-secao">
        <h4>Para mim</h4>
        <ControleDeNotificacoes />
        <label className="pchat-check">
          <input type="checkbox" checked={!!comTexto} disabled={comTexto === null} onChange={(e) => mudarTexto(e.target.checked)} />
          <span>Mostrar o começo do texto na notificação do aparelho <small>(aparece na tela bloqueada, à vista de quem passar)</small></span>
        </label>
        <div className="pchat-sons" role="radiogroup" aria-label="Som de mensagem nova">
          <span className="pchat-sons-rotulo">Som de mensagem nova <small>(toca com o chat aberto; com tudo fechado, o aviso usa o som do Windows)</small></span>
          {SONS.map((s) => (
            <div key={s.id} className={`pchat-som ${som === s.id ? "escolhido" : ""}`}>
              <label>
                <input type="radio" name="som-do-aviso" value={s.id} checked={som === s.id} disabled={som === null} onChange={() => mudarSom(s.id)} />
                <span>{s.nome}</span>
              </label>
              <button type="button" className="pchat-btn icone" aria-label={`Ouvir ${s.nome}`} title="Ouvir" onClick={() => tocarAviso(s.id)}><Ic d={ICONE.play} size={13} /></button>
            </div>
          ))}
        </div>
      </section>
      {config?.pode_configurar && (
        <section className="pchat-secao">
          <h4>Unidade</h4>
          {CAMPOS_DA_UNIDADE.map(({ campo, rotulo }) => (
            <label key={campo} className="pchat-campo-rotulo">
              {rotulo}
              <input
                className="pchat-busca" type="number" min="0" inputMode="numeric" value={valores[campo]}
                onChange={(e) => setValores((v) => ({ ...v, [campo]: e.target.value }))}
              />
            </label>
          ))}
          <div className="pchat-modal-acoes">
            <button type="button" className="pchat-btn enviar texto" disabled={salvando} onClick={salvarUnidade}>Salvar a unidade</button>
          </div>
        </section>
      )}
    </Modal>
  );
}
